module.exports = __webpack_public_path__ + "static/family-1-7204f665ffcacf1d2e15deb96a69b3fd.jpg";